import styled from 'styled-components'

const Home = () => {
  return (
    <PageView>
      <Title>BDMS Application</Title>
      Bangkok Dusit Medical Services (BDMS) is one of the most prestigious
      hospital networks in the Asia-Pacific region
    </PageView>
  )
}

const PageView = styled.div`
  border-radius: 10px;
  padding-top: 80px;
  text-align: center;
`

const Title = styled.h2``

export default Home
